import {MarcheNegocie} from './MarcheNegocie';
export class Procedure {

	public procedureAdaptee: string;

	public appelRestreint: string;

	public marcheNegocie: MarcheNegocie;

	public appelOuvert: string;

	public concoursRestreint: string;

	public dialogueCompetitif: string;

	public concoursOuvert: string;

	public autres: string;

	constructor() {
		 		this.procedureAdaptee = '';
		this.appelRestreint = '';
		this.marcheNegocie = new MarcheNegocie();
		this.appelOuvert = '';
		this.concoursRestreint = '';
		this.dialogueCompetitif = '';
		this.concoursOuvert = '';
		this.autres = '';

	}
}
